import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { Subject, Subscription } from "rxjs"
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';

import { ManualControl } from './manual-control.model'
import { ThingService } from '../thing.service'

@Component({
    selector: 'app-manual-control',
    templateUrl: './manual-control.component.html',
    styleUrls: ['./manual-control.component.css']
})
export class ManualControlComponent implements OnInit {
    @Input()
    public thingName: string
    @Input()
    public stoveTemperatureEnabled: boolean;

    public showControllers: boolean = false
    public manualControl: ManualControl
    public syncing: boolean = false
    private modelChanged: Subject<ManualControl> = new Subject<ManualControl>();
    private thingReadySubscription: Subscription
    private thingUpdateSubscription: Subscription

    constructor(private thingService: ThingService) {
        this.modelChanged
            .debounceTime(500)
            .subscribe(() => this.update())
    }

    ngOnChanges(changes: SimpleChanges) {
        let thingChange = changes['thingName']
        if (thingChange && thingChange.currentValue) {
            this.loadManualControl(thingChange.currentValue)
        }
    }

    ngOnInit() {
        this.thingReadySubscription = this.thingService.readyObservable.subscribe(thingName => {
            if (this.thingName && this.thingName === thingName) {
                this.loadManualControl(this.thingName)
            }
        })
        this.thingUpdateSubscription = this.thingService.thingsObservable.subscribe(thing => {
            if (this.manualControl && this.thingName && this.thingName === thing.name) {
                if (thing.stateObject && thing.stateObject['mm']) {
                    let received: ManualControl = ManualControl.fromShadow(thing.stateObject['mm'])
                    if (this.manualControl.equals(received)) {
                        this.syncing = false
                    } else {
                        // RELOAD if mm changed?
                        console.log('Thing mm field not in sync, ' + this.manualControl.toShadow() + ' vs ' + thing.stateObject['mm'])
                    }

                }
            }
        })
    }

    ngOnDestroy() {
        if (this.thingReadySubscription) {
            this.thingReadySubscription.unsubscribe()
        }
        if (this.thingUpdateSubscription) {
            this.thingUpdateSubscription.unsubscribe()
        }
    }

    private loadManualControl(thingName: string): void {
        let thing: any = this.thingService.getThingByName(thingName)
        if (thing && thing.stateObject) {
            let mmField: string = thing.stateObject['mm']
            if (ManualControl.validate(mmField)) {
                this.manualControl = ManualControl.fromShadow(mmField)
            } else {
                if (mmField || mmField === "") {
                    console.log('Invalid mm field "' + mmField + '", using default values')
                    this.manualControl = new ManualControl(false, 70, 0, 120)
                }
            }
        }
    }

    private update(): void {
        this.syncing = true
        let payload: any = {}
        payload.state = {}
        payload.state.desired = {}
        payload.state.desired['mm'] = this.manualControl.toShadow()
        this.thingService.updateShadow(this.thingName, payload)
    }

    public durationTime(): any {
        let hours: number = Math.floor((this.manualControl.duration / 60))
        let minutes: number = this.manualControl.duration - (hours * 60)
        return { hours: hours, minutes: minutes }
    }

    public triggerModelChanged(): void {
        this.modelChanged.next(this.manualControl)
    }

    public setPower(enabled: boolean): void {
        if (this.manualControl.power !== enabled) {
            this.manualControl.power = enabled
            // send update immediately from on/off button
            this.update()
        }
    }

    public deviceOn(): boolean {
        if (!this.thingName) {
            return false
        }
        let thing: any = this.thingService.getThingByName(this.thingName)
        if (!thing || thing.stateObject === undefined || thing.stateObject.pr1 === undefined) {
            return false
        }
        let pr1Value: number = Number(thing.stateObject.pr1)
        return pr1Value === 255 ? false : true;
    }

}



// WEBPACK FOOTER //
// /Users/mjahoo/workspace/rento/git/saunasampo-monitor/src/app/device/manual-control/manual-control.component.ts